module.exports = __webpack_public_path__ + "static/images/components/FamePoints/images/icon-fame-points.9a0c9d31.png";


//////////////////
// WEBPACK FOOTER
// ./components/FamePoints/images/icon-fame-points.png
// module id = 2596
// module chunks = 11